import { Record } from "immutable";
import { AenProviderFee } from "models/interfaces/aen-resources/aen-provider-fee";

// -------------------------------------------------------------------------------------------------
// #region Default Values
// -------------------------------------------------------------------------------------------------

const defaultValues: AenProviderFee = {
    id: undefined,
    amount: undefined,
    year: 0,
    deadline: undefined,
};

// #endregion Default Values

// -------------------------------------------------------------------------------------------------
// #region Record
// -------------------------------------------------------------------------------------------------

class AenProviderFeeRecord extends Record(defaultValues) implements AenProviderFee {
    // -------------------------------------------------------------------------------------------------
    // #region Constructor
    // -------------------------------------------------------------------------------------------------

    constructor(params?: Partial<AenProviderFee>) {
        params = params ?? Object.assign({}, defaultValues);

        super(params);
    }

    // #endregion Constructor


    public with(values: Partial<AenProviderFee>): AenProviderFeeRecord {
        return new AenProviderFeeRecord(Object.assign(this.toJS(), values));
    }

    // #endregion Public Methods
}

// #endregion Record

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export { AenProviderFeeRecord };

// #endregion Exports
